import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TOWNS } from "@/data/site";

export default function TownsGrid() {
  return (
    <section id="towns" className="py-28 md:py-40 bg-stone-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-20">
          <p className="overline mb-7">Areas covered</p>
          <h2 className="font-serif text-[2.8rem] sm:text-[3.6rem] md:text-[4.8rem] leading-[1.02] tracking-tight text-stone-900">
            Wedding videography across
            <br />
            <em className="italic font-normal text-stone-600">every Essex postcode.</em>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-y-14 gap-x-12">
          {TOWNS.map((t) => (
            <Link
              key={t.slug}
              to={`/wedding-videographer-${t.slug}`}
              data-testid={`town-card-${t.slug}`}
              className="group block"
            >
              <p className="overline text-stone-500 mb-3">{t.postcode}</p>
              <h3 className="font-serif text-[2.6rem] md:text-[3rem] text-stone-900 group-hover:italic transition-all leading-none">
                {t.name}
              </h3>
              <div className="w-10 h-px bg-stone-300 my-5 group-hover:w-20 group-hover:bg-stone-700 transition-all" />
              <p className="font-serif text-stone-600 text-[1.05rem] leading-relaxed">
                Wedding videographer serving {t.name} &amp; surrounding villages.
                <em className="italic"> {t.drivingTime}</em>.
              </p>
              <span className="mt-5 inline-flex items-center gap-2 font-serif italic text-stone-700">
                View {t.name}
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
